import React from "react";
import Loading from "Util/Loading";
import ProcessingBar from "Util/Processingbar";

const DeliverySection = ({ operator = {}, isLoading }) => {
  return (
    <div>
      <h3 className="font-semibold text-lg mb-3">Delivery</h3>
      {isLoading ? (
        <ProcessingBar />
      ) : (
        <div className="border rounded-lg p-4 flex justify-between bg-gray-100  border-gray-400 gap-x-2">
          <div className="mr-2">
            <p className="font-medium">
              {operator.name},{operator.town}
            </p>
            <p className="text-sm text-gray-500">{operator.address} </p>
            <p className="text-xs text-gray-400">Usually ready in 1 hour</p>
          </div>

          <span className="font-semibold">FREE</span>
        </div>
      )}
    </div>
  );
};

export default DeliverySection;
